(function () {
  //当新标签页打开时，如果 sessionStorage 为空，说明它是新页面，需要从其他标签页获取数据。
  if (sessionStorage.length == 0) {
    // 向 localStorage 写入键 getSessionStorage，触发其他标签页的 storage 事件（当前页面不会触发自己的事件）。
    localStorage.setItem('getSessionStorage', Date.now());
  };
  // 所有标签页都会监听 storage 事件（由 localStorage 变化触发），并根据事件类型处理数据同步。
  window.addEventListener('storage', function (event) {
    //已有标签页监听到 getSessionStorage 事件（来自新标签页的请求）
    if (event.key == 'getSessionStorage') {
      //将当前标签页的 sessionStorage 数据序列化为 JSON，存入 localStorage 的 sessionStorage 键。
      localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
      //立即移除 sessionStorage 键，触发 storage 事件通知新标签页。
      localStorage.removeItem('sessionStorage');

    } else if (event.key == 'sessionStorage' && event.oldValue !== null) { //新标签页监听到 sessionStorage 键的变化（已有标签页的响应）
      // 解析 localStorage 中的 sessionStorage 数据。
      var data = JSON.parse(event.oldValue);
      //将数据写入新标签页的 sessionStorage。
      for (key in data) {
        sessionStorage.setItem(key, data[key]);
      }

    } else if (event.key == 'changeSessionStorage') { //监听到 changeSessionStorage 事件（其他标签页数据变更通知）。
      var data = JSON.parse(localStorage.getItem("sessionStorage")); //从 localStorage 获取最新的 sessionStorage 数据。
      //更新当前标签页的 sessionStorage。
      for (key in data) {
        sessionStorage.setItem(key, data[key]);
      }
      //5 秒后清理 localStorage 中的 sessionStorage 键，避免数据残留。
      setTimeout(() => {
        localStorage.removeItem("sessionStorage");
      }, 5000);
    }
  });
})();